<template>
  <div class="clock-total" >
    <div class="total-con" :class="{'end':unlockCount==0,'showUn':more}">
      <div class="close iconfont icon-close-line" @click="()=>{$emit('hide');more= false}"></div>
      <template v-if="unlockCount>0">
        <h3 v-if="unlockCount !=999">
          <span class="num">{{unlockCount}}</span>
          <em>个未打卡景点</em>
          <span class="now">打卡当前位置</span>
        </h3>
        <div class="un-clock" >
          <!-- <span>打卡当前位置</span> -->
          <p class="curPos" @click="showUnlock" v-if="curPos">
              <em>{{curPos.name}}</em>
              <i class="iconfont icon-arrow-down"></i>
            </p>
          <span class="num-clock">{{clockNum || 0}}人已打卡</span>
          <van-button round class="clockBtn"  @click="clock" :disabled="locking">立即打卡</van-button>
        </div> 
      </template>   
      <div class="clock-end" v-else>
        <van-image :src="hz" fit="contain"></van-image>
        <div class="tips">
          <h4>恭喜您！</h4>
          <p>景点已全部打卡完成~</p>
        </div>
      </div>
    </div>
    <transition name="slideDown"> 
      <div class="unlockBox " v-show="more" v-if="list">
        <div class="srollbox"  :style="{'max-height':maxHeight+'px'}">
          <div class="clock-list " v-if="list">
            <div class="clock-item" :class="{'active':curPos && curPos.id == item.id}" v-for="item in list" @click="chooseOne(item)">
              <van-image :src="showpath + item.cover_img" fit="cover"></van-image>
              <p>{{item.name}}</p>
            </div>
          </div>
        </div>
        
      </div>
    </transition>
  </div>
</template>

<script>
import hz from "@/assets/images/hz.png"
export default {
  name: 'sClockTotal',
  props: {markedId:String | Number, clockId:String |Number},
  data(){
    return{
        hz,
       more:false,
       list:null,
       curPos:null,
       unlockCount:999,
       maxHeight:50,
       locking:false,
       clockNum:null,
    }
  },
  watch:{
    
  },
  mounted() {
    if(!this.markedId && !this.clockId){
      this.getList()
    }
    // if(this.markedId && this.clockId){
    //   this.getList()
    // }
  },
  methods:{
    showUnlock(){
      this.more= !this.more
    },
    posNow(obj){
      if(obj && !this.curPos){
        this.getList(obj)
        return
      } 
      if(obj && this.curPos){
        if(typeof(obj) !='object'){
          this.locking = false
          this.getList(obj)
          return;
        }
        if(obj.id!= this.curPos.id){
          this.locking= false
          this.getList();
        }else{
          this.locking = true
          this.getList(obj);
        }
        return
      }
      this.locking = false
    },
    
    chooseOne(item){
      this.curPos = {
        name:item.name,
        id:item.id,
        cover_img:item.cover_img
      }
      this.more = false
      this.locking = false
      if(item.id)this.getSumCount(item.id);
    },
    getList(markPos){
      this.$api.clockApi.getList({
        type:2,
      }).then(res=>{
        if(res && res.data){
          this.showpath = res.showpath
          let list = res.data
          this.list = list
          this.unlockCount = list.length
          if( typeof(markPos) =='object'){
            this.locking =true
            this.curPos = markPos
          }else{
            let nextOne
            if(markPos){
              nextOne = list.find(t=>{return t.id == markPos})
              !nextOne && (nextOne = list.length>0?list[0]:null)
            }else{
              nextOne = list.length>0?list[0]:null
            }
            this.locking =false
            if(nextOne){
              this.curPos = {
                name:nextOne.name,
                id:nextOne.id,
                cover_img:nextOne.cover_img
              }
            }else{
              this.curPos = null
            }
          }
          this.getMaxHeight()
          if(this.curPos && this.curPos.id)this.getSumCount(this.curPos.id);
        }
      })
    },

    clock(){
      if(!this.curPos) return;
      this.locking = true
      let curPos = this.curPos
      this.$api.clockApi.add({
        scenic_id:curPos.id,
        scenic_name:curPos.name,
        scenic_picture: curPos.cover_img
      }).then(res=>{
        if(res && res.code==0){
          // this.$toast.success("打卡成功")
          this.$parent.$parent.$parent.updateTimestat = new Date().getTime()+123;
          this.getList()
          
          setTimeout(() => {
            this.$emit("update")
            this.$emit('clock',curPos.id)
          }, 800);
        }else{
          this.$toast.fail(res.msg)
          this.locking = false
        }
      })
      
    },

    getMaxHeight(){
      setTimeout(() => {
        let height = this.$parent.$refs.clockBox.offsetHeight
        if(height<=0) return;
        this.maxHeight = height + 30
      }, 600);
      
    },
    // 获取打卡数量
    async getSumCount(id){
      let res = await this.$api.mapApi.getSumCount(id);
      if(res && res.code==0){
      this.clockNum = res.data;
      }else{
        this.$toast.fail(res.msg)
      }
    },
  },
}
</script>
<style scoped lang="scss">
  .clock-total{
    background: #fff;
    box-shadow: 0 4px 10px rgba($color: #000000, $alpha: 0.12);
    box-sizing: border-box;
    margin:0 15rem;
    border-radius: 15rem;
    margin-bottom: 15rem;
    position: relative;
    z-index: 2;
    height: 112rem;
    
    .total-con{
      background: #fff;
      position: relative;
      z-index: 5;
      padding: 15rem 15rem 0;
      border-radius: 15rem;
      overflow: hidden;
      // height: 112rem;
      height: 100%;
      box-sizing: border-box;
      &.end{
        background: linear-gradient(180deg,  #ffcd5e -100%, #ffe2a2 -40%, #ffffff 120%);
        padding-top: 0;
      }
      &.showUn{
        border-radius: 15rem 15rem 0 0;
      }
      
    }
    .close{
      font-size: 24rem;
      color: var(--fontGray);
      position: absolute;
      right: 10rem;
      top: 0rem;
      cursor: pointer;
      z-index: 5;
    }
    h3{
      border-bottom: 1px solid #ECECEC;
      color: #3D3D3D;
      padding-bottom: 5rem;
      position: relative;
      .num{
        font-size: 24rem;
        margin-right: 5rem;
      }
      .now {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        text-align: right;
        font-size: 14rem;
      }
    }
    .un-clock{
      padding: 14rem 0 0;
      display: flex;
      align-items: center;
      font-size: 14rem;
      color: #666666;
      &>span{
        white-space: nowrap;
      }
      .curPos{
        // margin-left: 8rem;
        margin-right: 8rem;
        cursor: pointer;
        position: relative;
        white-space: nowrap;
        display: flex;
        align-items: center;
        em{
          color: var(--mainColor);
          display: inline-block;
          max-width: 110rem;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .clockBtn{
        margin-left: auto;
        height: 28rem;
        color: #fff;
        border: none;
        font-size: 14rem;
        font-weight: bold;
        white-space: nowrap;
        // background: linear-gradient(95deg, #ff7534d6 0%, #fe6033 100%);
        background: var(--mainColor);
      }
    }
  }

  .clock-list{
    display: flex;
    flex-wrap: wrap;
    // position: absolute;
    // z-index: 2;
    background: #fff;
    width: calc(100vw - 30rem);
    left: 0;
    box-sizing: border-box;
    padding:15rem;
    // box-shadow: 0 4rem 4rem rgba($color: #000000, $alpha: 0.12);
    // border-radius: 0 0 15rem 15rem;
    .clock-item{
      width: 50%;
      display: flex;
      align-items: center;
      margin-bottom: 12rem;
      &.active{
        color: var(--mainColor);
      }
      .van-image{
        width: 31rem;
        height: 31rem;
        margin-right: 9rem;
        flex-shrink: 0;
      }
      p{
        white-space: nowrap;
        max-width: calc(100% - 31rem - 10rem);
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

.unlockBox{
  position: absolute;
  z-index: 3;
  left: 0;
  // margin-top: -10rem;
  box-shadow: 0 4rem 4rem rgba($color: #000000, $alpha: 0.12);
  border-radius: 0 0 15rem 15rem;
  background: #fff;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  .clock-list{
    padding-top: 0;
  }
  .srollbox{
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    box-sizing: border-box;
  }
}

.clock-end{
  width: 100%;
  display: flex;
  .van-image{
    width: 92rem;
    height: 112rem;
  }
  .tips{
    width: calc(100%  - 92rem);
    text-align: center;
    color: #333333;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    line-height: 1.8;
    padding-top: 10rem;
    h4{
      font-size: 20rem;
      font-weight: bold;
    }
    p{
      font-size: 18rem;
      margin-top: 5rem;
    }
  }
}
</style>